import { Refresh } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { runInAction } from 'mobx';

import React from 'react';
import EscaninhoService from '../../services/EscaninhoService';
import EscaninhoStore from '../../store/EscaninhoStore';
import ProcessoExpandidoStore from '../../store/ProcessoExpandidoStore';
import ProcessoStore from '../../store/ProcessoStore';
import InformacoesProcessoService from '../../services/InformacoesProcessoService';
import UsuarioStore from '../../store/UsuarioStore';

interface IPropsBotaoRecarregarProcessos {
}


export default class BotaoRecarregarProcessos extends React.Component<IPropsBotaoRecarregarProcessos> {

    recarregarProcessos = async () => {
        runInAction(() => {
            ProcessoStore._processos.forEach(proc => {
                proc.minutas = [];
                proc.partes = undefined;
                proc.idsMinutasComentadas = [];
                proc.assuntosProcesso = [];
                proc.indicadores = [];
                proc.etiquetas = [];
                proc.pecas = [];
                proc.triagemLivre = '';
                proc.triagem = undefined;
                proc.temas = [];
                proc._mostrar = true;
                proc.peticoesPendentes = [];
                proc.resultadoJulgamentoProcesso = undefined;
                proc.situacaoDeInclusaoEmPauta = '';
                proc.pauta = undefined;
                proc.pecasPeticoesPendentes = [];
                proc.tipoJulgamento = undefined;
                proc.background = '';
                proc.impedimentos = [];
                proc.agravoProvido = false;
                proc.favorito = false;
                proc.retorno = false;
                proc.controleGabinete = undefined;
                proc.numeroCpfResponsavel = '';
            })
            ProcessoStore.carregouIndicadores = false;
            EscaninhoStore.expandedCardIndicadores = false;
            ProcessoExpandidoStore.idProcessoPainelExpandido = '';
        });
        await EscaninhoService.carregarProcessosDoGabinete();
        EscaninhoService.ajustarFiltros(false);
        // BTV desativado: os dados retornados não têm consumidores no frontend.
        // await InformacoesProcessoService.buscarDadosProcessoBTV(UsuarioStore.gabinete);
    }

    render() {
        return (
            <Tooltip title='Recarregar dados do GE'>
                <div style={{ color: 'white' }}>
                    <IconButton color='inherit' onClick={this.recarregarProcessos} aria-label='Recarregar dados do GE'>
                        <Refresh />
                    </IconButton>
                </div>
            </Tooltip>
        );
    }
}
